import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-travelers-list',
  templateUrl: './modal-travelers-list.component.html',
  styleUrl: './modal-travelers-list.component.scss'
})
export class ModalTravelersListComponent {

}
